import React from 'react'
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Slide from '../Slide/index';
import Credit from '../Credits';
import Quote from '../Quote';
import Overview from '../Overview';
import NextSlide from '../NextSlide';
import PrevSlide from '../PrevSlide';
import ShowMeMore from '../ShowMeMore';
import styled from 'styled-components';

const Div = styled.div`
  height: ${() => window.innerHeight + 'px' };
  opacity: 0;
  position: relative;
  transition: opacity 1s;
  width: ${() => window.innerWidth + 'px' };

  &.is-active {
    opacity: 1;
  }

  &.is-dimmed {
    opacity: 0.5;
  }
`;

const Slides = (props) => {

  const { credits, creditTitle, currentSlideNumber, deviceType, id, folioNavigationEnabled, overview, quote,
    setCurrentSlide, slides, slidesEnabled, supportsGrids, title, toggleFolioNav, totalSlides,
    location } = props;

  const classes = {
    'is-active': slidesEnabled,
    'is-dimmed': slidesEnabled && props.location && props.location === '/folio'
  };

  const creditPath = credits
      && credits.background
      && credits.background.backgroundImage
      && credits.background.backgroundImage.url;

  const deck = slides && slides.map((item, index) => <Slide bgColor={ item.bgColor }
                                                            color={ item.color }
                                                            currentSlideNumber={ currentSlideNumber }
                                                            deviceType={ deviceType }
                                                            id={ item.id }
                                                            index={ index }
                                                            key={`${index}-slide`}
                                                            layouts={ item.layout || [] }
                                                            objectFit={ item.objectFit }
                                                            supportsGrids={ supportsGrids }
                                                            location={ location }
  />);

  return (
      <Div className={`wrapper ${classnames(classes)}`}>
        { currentSlideNumber === 1 &&
          <Quote quotePosition={ quote && quote.position }
                 quoteColor={ quote && quote.color }
                 quote={ quote && quote.copy }
                 citation={ quote && quote.citation }
          /> }
        { currentSlideNumber === 2 &&
          <Overview overviewPosition={ overview && overview.position }
                    overviewColor={ overview && overview.color }
                    overviewEnabled={ overview && overview.enabled }
                    copy={ overview && overview.copy }
                    title={ title }
          /> }
        { title &&
        <div className={`c-project c-project--${title}`}>
          { deck }
          <Credit path={ creditPath }
                  fields={ credits && credits.fields }
                  title={ creditTitle }
                  totalSlides={ totalSlides+1 }
                  enabled={ credits && credits.enabled }
                  bgColor={ credits.background && credits.background.backgroundColor }
                  currentSlideNumber={ currentSlideNumber }
          />
        </div> }
        { deviceType === 'desktop' &&
        <NextSlide setCurrentSlide={ setCurrentSlide }
                   currentSlide={ currentSlideNumber }
                   totalSlides={ totalSlides }
        /> }
        { deviceType === 'desktop' &&
        <PrevSlide setCurrentSlide={ setCurrentSlide }
                   currentSlide={ currentSlideNumber }
                   totalSlides={ totalSlides }
        /> }
        <ShowMeMore handleClick={ toggleFolioNav }
                    setCurrentSlide={ setCurrentSlide }
                    currentSlide={ currentSlideNumber }
                    totalSlides={ totalSlides }
                    folioNavigationEnabled={ folioNavigationEnabled }
        />
      </Div>
  );
};

Slides.propTypes = {
  credits: PropTypes.object,
  creditTitle: PropTypes.string,
  currentSlideNumber: PropTypes.number,
  deviceType: PropTypes.string,
  id: PropTypes.string,
  folioNavigationEnabled: PropTypes.bool,
  overview: PropTypes.object,
  quote: PropTypes.object,
  setCurrentSlide: PropTypes.func,
  slides: PropTypes.array,
  slidesEnabled: PropTypes.bool,
  supportsGrids: PropTypes.bool,
  title: PropTypes.string,
  toggleFolioNav: PropTypes.func,
  totalSlides: PropTypes.number
};

export default Slides;



// WEBPACK FOOTER //
// ./src/components/Slides/index.js